import { gql } from '@efficiently/client-core-graphql-models';

export const CREATE_PROJECT_DESIGN_CHANGE_DOCUMENTS = gql(`
	mutation CreateProjectDesignChangeDocuments($_id: ID!, $contentIds: [ID!]!) {
		createProjectDesignChangeDocuments(_id: $_id, contentIds: $contentIds) {
			contentId
			fileName
			url
			size
			mimeType
		}
	}
`);
